export default {
    title: "O-I",
    support: "Soutien",
    dashboard: "Tableau de bord"
}